enum VOTING_OPTIONS {
    FOR = 'yes',
    AGAINST = 'no',
}

export { VOTING_OPTIONS };
